import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { HubSpotLinkedService } from 'app/model/linkedservice/hub-spot.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { CONNECTOR_VERSION20 } from 'app/services/globals';
import { driverVersions } from 'app/registries/consts/tabular-consts';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HubSpotLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            version: '*',
            typeProperties: {
                clientId: '*',
                clientSecret: 'secret',
                accessToken: 'secret',
                refreshToken: 'secret',
                useEncryptedEndpoints: '*',
                useHostVerification: '*',
                usePeerVerification: '*',
                encryptedCredential: '*'
            }
        }
    }
})
export class HubSpotLinkedServiceAdapter extends LinkedServiceAdapter<HubSpotLinkedService> {
    protected modelConstructor(): new () => HubSpotLinkedService {
        return HubSpotLinkedService;
    }

    protected model(): IModel {
        return HubSpotLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: HubSpotLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.HubspotLinkedService;
        properties.type = Metamodel.modelFor(HubSpotLinkedService).name;
        if (linkedService.version === driverVersions.v2) {
            properties.version = CONNECTOR_VERSION20;
        }
        properties.typeProperties = {
            clientId: linkedService.clientId,
            clientSecret: passwordOrAKVtoSecretBase(linkedService.clientSecret, this.context),
            accessToken: passwordOrAKVtoSecretBase(linkedService.accessToken, this.context),
            refreshToken: passwordOrAKVtoSecretBase(linkedService.refreshToken, this.context),
            useEncryptedEndpoints: linkedService.useEncryptedEndpoints,
            useHostVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.useHostVerification : undefined,
            usePeerVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.usePeerVerification : undefined
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: HubSpotLinkedService): Promise<HubSpotLinkedService> {
        const properties = linkedServiceResource.properties as Model.HubspotLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.HubspotLinkedServiceTypeProperties = properties.typeProperties;
        linkedService.version = properties.version == CONNECTOR_VERSION20 ? driverVersions.v2 : driverVersions.v1;
        linkedService.isLegacyConnector = linkedService.version !== driverVersions.v2;
        linkedService.clientId = typeProperties.clientId;
        linkedService.clientSecret = secretBaseToPasswordOrAKV(typeProperties.clientSecret, true, this.context);
        linkedService.accessToken = secretBaseToPasswordOrAKV(typeProperties.accessToken, true, this.context);
        linkedService.refreshToken = secretBaseToPasswordOrAKV(typeProperties.refreshToken, true, this.context);
        linkedService.useEncryptedEndpoints = typeProperties.useEncryptedEndpoints;
        linkedService.useHostVerification = typeProperties.useHostVerification;
        linkedService.usePeerVerification = typeProperties.usePeerVerification;

        return linkedService;
    }
}
